module.exports = __webpack_public_path__ + "static/media/film-alt.503c878d.svg";